import React, { useContext, useEffect, useMemo, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import { Label } from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@mui/material";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import {
  CustomModal,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";
import {
  AddModalStyles,
  ViewItemModalStyles,
} from "../../../../../../styles/CustomModalStyles";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import {
  AutocompleteInput,
  EMPTY_STRING,
  emptyMessage,
} from "../../../../../../utils/constants";
import Subsidiary, { PageFor } from "../approved/Subsidiary";
import Edit from "../../../../../../images/EditProfile.svg";
import Delete from "../../../../../../images/Delete.svg";
import { CustomDrawer } from "../../../../../../styles/CustomDrawerStyles";
import SelectedSuppliers from "../../material/SelectedSuppliers";
import {
  LicenseTypes,
  MaterialRequestStatus,
  Operation,
} from "../../../../../../utils/Enum.types";
import { responseType, rfqForm } from "../../../../../../utils/formTypes";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import { LabelProps, rfqFormData } from "../../../../../../utils/types";
import {
  AtsMrfMst,
  AtsMrfMstOrderField,
  GetMrfsVars,
  MrfQueryType,
} from "../../material/queries/types";
import { AppContext } from "../../../../../../context/context";
import { AppContext as LocalStateContext } from "./statesProvider/materialContext";

import { useLazyQuery, useMutation } from "@apollo/client";
import { MrfByNode } from "../../material/queries/queries";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";

import { GetSqlNumber } from "../../../../../../queries/queries";
import {
  GetSqlNumberResult,
  GetSqlNumberVars,
  tableKey,
} from "../../../../../../queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { GetMrfsForRFQs, GetRfqByNode } from "../queries/queries";
import {
  AddRfqResult,
  AddRfqVars,
  AtsMrfMstForRfqsEdge,
  AtsRfqMstData,
  GetMrfsForRFQsResult,
  rfqPendingItemType,
  UpdateRfqResult,
  UpdateRfqVars,
} from "../queries/types";
import { rfqStatesType } from "./statesProvider/materialReducer";
import { formDates } from "../../material/ApprovedList";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import { AddRfq, UpdateRfq } from "../queries/mutations";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import MessageModal from "../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../pages/LoadingModal";
import AddQuotationItemModal from "./AddQuotationItemModal";
import Navbar from "../../../../../common/layout/Navbar";
import { useHotKey } from "../../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../../utils/Enum.keys";

export interface itemsType extends rfqFormData {
  suppliers: responseType[];
  item: rfqPendingItemType;
  mrf: AtsMrfMstForRfqsEdge;
}

const Add = () => {
  const navigate = useNavigate();
  const { Purchase } = useAssetTableJson();

  const [selectSubsidary, setSelectSubsidary] = useState(false);
  const [selectedSuppliers, setSelectedSuppliers] = useState(false);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [mrfs, setMrfs] = useState<AtsMrfMstForRfqsEdge[]>([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [addItemOpretion, setAddItemOpretion] = useState<Operation>(
    Operation.CREATE
  );

  const [message, setMessage] = useState(emptyMessage);

  const [AddRFQ, { loading: AddRfqLoading }] = useMutation<
    AddRfqResult,
    AddRfqVars
  >(AddRfq);
  const [UpdateRFQ, { loading: UpdateRfqLoading }] = useMutation<
    UpdateRfqResult,
    UpdateRfqVars
  >(UpdateRfq, {
    onError: (e) =>
      setMessage({
        message: e.message,
        flag: true,
        operation: Operation.NONE,
      }),
  });

  const [selectedItemsId, setSelectedItemId] = useState<Set<number>>(new Set());
  const initialRqForm: rfqForm = {
    lastDateForSubmission: "",
    rfqPreparedBy: "",
    rfqAuthorisedBy: "",
    tc: "",
    payTerms: "",
    remarks: "",
  };
  const [rqForm, setRqForm] = useState<rfqForm>(initialRqForm);
  const [addItemModal, setAddItemModal] = useState(false);

  const { customer_id, rfq_id, company_id } = useUrlParams();

  const [GetRfqNode, { data: rfqData, loading: GetRfqByNodeLoading }] =
    useLazyQuery<{ node: AtsRfqMstData }, nodeVar>(GetRfqByNode);

  const [GetNo, { data: noData, loading: GetSqlNumberLoading }] = useLazyQuery<
    GetSqlNumberResult,
    GetSqlNumberVars
  >(GetSqlNumber);

  const autoCompleteRefs = document.getElementsByClassName(AutocompleteInput);

  const isAutoMounted = autoCompleteRefs && autoCompleteRefs.length === 5;

  const [GetMrfRfqs, { data: mrfData, loading, fetchMore }] = useLazyQuery<
    GetMrfsForRFQsResult,
    GetMrfsVars
  >(GetMrfsForRFQs);

  const [searchMrf, setSearchMrf] = useState("");

  const { state } = useContext(AppContext);
  const { state: localState, dispatch } = useContext(LocalStateContext);

  
  const { data: todaysDateData, serverDate } = useServerDateandTime();

  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: "",
  });

  const [GetMrf, { data, loading: MrfByNodeLoading }] = useLazyQuery<
    { node: AtsMrfMst },
    nodeVar
  >(MrfByNode);

  const { user_details } = useLoggedInUserDetails();

  const [items, setItems] = useState<itemsType[]>([]);

  const inputJson: LabelProps[] = [
    {
      labelName: "Last Date for Submission",
      inputName: "lastDateForSubmission",
      dataType: "date",
    },
    {
      labelName: "RFQ Prepared By",
      inputName: "rfqPreparedBy",
    },
    {
      labelName: "RFQ Authorized By",
      inputName: "rfqAuthorisedBy",
    },
  ];

  const textAreaJson: LabelProps[] = [
    {
      labelName: "General Terms & Condition",
      inputName: "tc",
    },
    {
      labelName: "General Payment Terms",
      inputName: "payTerms",
    },
  ];

  const handleRqValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setRqForm(() => ({
      ...rqForm,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (rfq_id) {
      GetRfqNode({
        variables: {
          id: rfq_id,
       
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setItems(
            data.node.rfqTrnDetails.map((rfq) => {
              const taxedValue =
                (rfq.mrf_trn_details.tax / 100) * rfq.mrf_trn_details.taxable;

              return {
                mrfNo: rfq.mrf_trn_details.mrf.mrfNo,
                mrfDate: toStandardDate(rfq.mrf_trn_details.mrf.mrfDate),
                udfDesc: rfq.mrf_trn_details.udfItemDesc,
                uom: rfq.mrf_trn_details.item.uom,
                presentStck: rfq.mrf_trn_details.presentStk,
                approxRate: rfq.mrf_trn_details.approxRate,
                approxQty: rfq.mrf_trn_details.acceptQty,
                approxTaxable: rfq.mrf_trn_details.taxable,
                tax: rfq.mrf_trn_details.tax,
                netValue: rfq.mrf_trn_details.taxable + taxedValue,
                terms: rfq.itemTerms,
                paymentTerms: rfq.itemPaymentTerms,
                remark: rfq.itemRemarks,
                taxedValue: taxedValue,

                subsidary: {
                  label: rfq.mrf_trn_details.mrf.subsidiary.name,
                  value: rfq.mrf_trn_details.mrf.subsidiary.id,
                },
                mrfId: rfq.mrf_trn_details.mrf.id,
                item: {
                  acceptQty: rfq.mrf_trn_details.acceptQty,
                  approxRate: rfq.mrf_trn_details.approxRate,
                  id: rfq.mrf_trn_details.id,
                  item: rfq.mrf_trn_details.item,
                  presentStk: rfq.mrf_trn_details.presentStk,
                  priority: rfq.mrf_trn_details.priority,
                  tax: rfq.mrf_trn_details.tax,
                  taxable: rfq.mrf_trn_details.taxable,
                  trnNeedBefore: rfq.mrf_trn_details.trnNeedBefore,
                  udfItemDesc: rfq.mrf_trn_details.udfItemDesc,
                  uom: rfq.mrf_trn_details.item.uom,
                },
                mrf: {
                  node: rfq.mrf_trn_details.mrf,
                  cursor: EMPTY_STRING,
                },
                suppliers: rfq.preferedSupplierDetails
                  .filter((sup) => Number(sup.id) !== 0)
                  .map((sup) => ({
                    label: sup.desc,
                    value: sup.id,
                  })),
              };
            }) as unknown as itemsType[]
          );
          setRqForm({
            lastDateForSubmission: data.node.lastDateRfqSubmission,
            payTerms: "",
            remarks: data.node.remarks,
            rfqAuthorisedBy: "",
            rfqPreparedBy: "",
            tc: "",
          });
        }
      });
    }
  }, [rfq_id, rfqData, GetMrf]);

  useEffect(() => {
    if (customer_id && company_id && state.ActiveFinYr) {
      GetNo({
        variables: {
          customerID: customer_id,
          companyID: company_id,
          tableKey: tableKey.RFQNO,
        
        },
      });
    }
  }, [customer_id, state.ActiveFinYr, company_id, GetNo]);

  useEffect(() => {
    if (customer_id && state.ActiveFinYr)
      GetMrfRfqs({
        variables: {
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: 6,
          name: searchMrf,
          start_date: "1/12/2024",
          end_date: "1/31/2024",
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsMrfMstOrderField.MRF_NO,
          },
          queryType: MrfQueryType.APPROVED_MRFS,
         
        },
      });
  }, [GetMrfRfqs, customer_id, state.ActiveFinYr, searchMrf]);

  useEffect(() => {
    if (customer_id && state.ActiveFinYr)
      GetMrfRfqs({
        variables: {
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: 6,
          name: searchMrf,
          start_date: toIsoDate(dates.startDate),
          end_date: toIsoDate(dates.endDate),
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsMrfMstOrderField.MRF_NO,
          },
          queryType: MrfQueryType.APPROVED_MRFS,
          
        },
      });
  }, [GetMrfRfqs, customer_id, state.ActiveFinYr, searchMrf]);

  useEffect(() => {
    if (mrfData && !loading) {
      const newData = mrfData.GetMrfs.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = mrfs.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setMrfs(updatedNewData);
      } else {
        setMrfs(newData);
      }
      setEndCursor(mrfData.GetMrfs.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [mrfData, loading]);

  const handleDelete = (id: number) => {
    setDeleteModal(!deleteModal);

    const updatedItems = items.filter((itm, index) => index !== id);
    const foundItem = items.find((itm, index) => index === id);
    if (foundItem) {
      const tempSet = selectedItemsId;
      tempSet.delete(foundItem.item.id);
      setSelectedItemId(tempSet);
    }
    setItems(updatedItems);
    setSelectedId(0);
    if (isAutoMounted) {
      (autoCompleteRefs[2] as HTMLInputElement).focus();
    }
  };

  const handleEditItem = (id: number) => {
    const foundItem = items.find((itm, index) => index === id);

    if (foundItem) {
      const { suppliers, item, mrf, ...rest } = foundItem;

      // setFormData(rest);
      dispatch({
        type: rfqStatesType.MRF,
        payload: {
          mrf,
        },
      });
      dispatch({
        type: rfqStatesType.SET_ITEM_ID,
        payload: {
          itm: item,
        },
      });
      dispatch({
        type: rfqStatesType.SUPPLIERS,
        payload: {
          selectedSuppliers: suppliers,
        },
      });
    }
  };
  const handleClear = () => {
    // setFormData(initialValues);
    setRqForm(initialRqForm);
    dispatch({
      type: rfqStatesType.MRF,
      payload: {
        mrf: null,
      },
    });
    dispatch({
      type: rfqStatesType.SET_ITEM_ID,
      payload: {
        itm: null,
      },
    });
    dispatch({
      type: rfqStatesType.SUPPLIERS,
      payload: {
        selectedSuppliers: [],
      },
    });
  };

  const totals = useMemo(() => {
    return items.reduce(
      (acc, itm) => {
        acc.presentStck = Number(acc.presentStck) + Number(itm.presentStck);
        acc.approxRate = Number(acc.approxRate) + Number(itm.approxRate);
        acc.acceptQty = Number(acc.acceptQty) + Number(itm.item.acceptQty);
        acc.approxTaxable =
          Number(acc.approxTaxable) + Number(itm.approxTaxable);
        acc.tax = Number(acc.tax) + Number(itm.tax);
        acc.taxedValue = Number(acc.taxedValue) + Number(itm.taxedValue);
        acc.netValue = Number(acc.netValue) + Number(itm.netValue);
        return acc;
      },
      {
        presentStck: 0,
        approxRate: 0,
        acceptQty: 0,
        approxTaxable: 0,
        tax: 0,
        taxedValue: 0,
        netValue: 0,
      }
    );
  }, [items]);

  const handleSubmit = async () => {
  
    if (rfq_id) {
      if (customer_id && state.ActiveFinYr && rfqData) {
        UpdateRFQ({
          variables: {
            customerId: customer_id,
            finYrId: state.ActiveFinYr ? state.ActiveFinYr.id : 0,
            
            user_details,
            rfqId: rfq_id,

            input: {
              rfqDate: toIsoDate(serverDate),
              remarks: rqForm.remarks as string,
              rfqNo: rfqData.node.rfqNo,
              lastDateRfqSubmission: toIsoDate(rqForm.lastDateForSubmission),
              generalPaymentTerms: rqForm.payTerms,
              generalTerms: rqForm.tc,
              itemsList: items.map((itm, index) => ({
                approxRate: Number(itm.approxRate),
                itemID: itm.item.item.id,
                itemPaymentTerms: itm.paymentTerms,
                itemRemarks: itm.remark,
                itemTerms: itm.terms,
                mrfID: itm.mrfId,
                mrfTrnID: itm.item.id,
                mrfTrnSlNo: index,
                priority: itm.item.priority,
                slNo: index,
                trnNeedBefore: toIsoDate(itm.item.trnNeedBefore),
                udfItemDesc: itm.item.udfItemDesc,
                trnQty: itm.item.acceptQty,
                preferredSupplierIds: itm.suppliers
                  .map((sup) => sup.value)
                  .join(";"),
              })),
            },
          },
        }).then(({ data }) => {
          if (data && data.UpdateRfq) {
            setMessage({
              flag: true,
              message: "Rfq Updated successfully",
              operation: Operation.CREATE,
            });
          }
        });
      }
    } else if (customer_id && state.ActiveFinYr && noData) {
      if (rqForm.lastDateForSubmission === "" || items.length === 0) {
        if (rqForm.lastDateForSubmission === "")
          setMessage({
            message: "Missing last date for Submission",
            flag: true,
            operation: Operation.NONE,
          });
        if (items.length == 0)
          setMessage({
            message: "Missing items list",
            flag: true,
            operation: Operation.NONE,
          });
      } else {
        AddRFQ({
          variables: {
            customerId: customer_id,
            finYrId: state.ActiveFinYr ? state.ActiveFinYr.id : 0,
            
            user_details,
            input: {
              rfqDate: toIsoDate(serverDate),
              remarks: rqForm.remarks as string,
              rfqNo: noData.GetSqlNumber.sqlNumber,
              lastDateRfqSubmission: toIsoDate(rqForm.lastDateForSubmission),
              generalPaymentTerms: rqForm.payTerms,
              generalTerms: rqForm.tc,
              itemsList: items.map((itm, index) => ({
                approxRate: Number(itm.approxRate),
                itemID: itm.item.item.id,
                itemPaymentTerms: itm.paymentTerms,
                itemRemarks: itm.remark,
                itemTerms: itm.terms,
                mrfID: itm.mrfId,
                mrfTrnID: itm.item.id,
                mrfTrnSlNo: index,
                priority: itm.item.priority,
                slNo: index,
                trnNeedBefore: toIsoDate(itm.item.trnNeedBefore),
                udfItemDesc: itm.item.udfItemDesc,
                trnQty: itm.item.acceptQty,

                preferredSupplierIds: itm.suppliers
                  .map((sup) => sup.value)
                  .join(";"),
              })),
            },
          },
        }).then(({ data }) => {
          if (data && data.AddRfq) {
            setMessage({
              flag: true,
              message: "Rfq Added successfully",
              operation: Operation.CREATE,
            });
          }
        });
      }
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      if (!rfq_id) {
        handleClear();
        setItems([]);
        setSelectedItemId(new Set());
      }
    }
    setMessage(emptyMessage);
  };

  useEffect(() => {
    if (state.ActiveFinYr) {
      setDates({
        endDate: state.ActiveFinYr.finEndDate.toString(),
        startDate: state.ActiveFinYr.finStDate.toString(),
      });
    }
  }, [state.ActiveFinYr]);

  useHotKey({
    handleFunc: () => {
      setAddItemOpretion(Operation.CREATE);
      setAddItemModal(!addItemModal);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>Request for quotation</Title>
      <div className="quotation__add">
        <div className="quotation__add--select row g-0">
          <div className="col-6">
            <div className="label-grid">
              <Label>Request for Quotation No.</Label>
              <Input
                disabled
                readonly
                value={
                  rfq_id && rfqData
                    ? rfqData.node.rfqNo
                    : noData
                    ? noData.GetSqlNumber.sqlNumber
                    : EMPTY_STRING
                }
              />
            </div>
          </div>
          <div className="col"></div>
          <div className="col-3 flex-end">
            <Label>Date :</Label>
            <Input
              type="date"
              value={toInputStandardDate(serverDate)}
              readonly
            />
          </div>
          <div className="col-2 flex-end">
            <Button
              mode="addnew"
              onClick={() => {
                setAddItemOpretion(Operation.CREATE);
                setAddItemModal(!addItemModal);
              }}
            >
              {" "}
              Material Item
            </Button>
          </div>
        </div>
        <div className="quotation__add--tableblock">
          <TableContainer className="quotation__add--table">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {Purchase.Quotation.Add.map((res, index) => {
                    return <TableCell key={index}>{res.headerName}</TableCell>;
                  })}
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((itm, index) => {
                  return (
                    <TableRow
                      className="quotation__add--table--edit-row"
                      key={index}
                    >
                      <TableCell
                        className="quotation__add--table--number"
                        id="td-center"
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell>{itm.mrfNo}</TableCell>
                      <TableCell className="quotation__add--table--onclick">
                        {toStandardDate(itm.mrfDate)}
                      </TableCell>
                      <TableCell className="quotation__add--table--onclick">
                        {itm.subsidary ? itm.subsidary.label : null}
                      </TableCell>
                      <TableCell className="quotation__add--table--remarks">
                        {itm.item.item.code.length
                          ? `${itm.item.item.desc} (${itm.item.item.code})`
                          : `${itm.item.item.desc}`}
                      </TableCell>
                      <TableCell className="quotation__add--table--number">
                        {itm.udfDesc}
                      </TableCell>
                      <TableCell className="quotation__add--table--number">
                        {itm.uom}
                      </TableCell>
                      <TableCell>{itm.presentStck}</TableCell>
                      <TableCell className="quotation__add--table--number">
                        {itm.approxRate}
                      </TableCell>
                      <TableCell className="quotation__add--table--number">
                        {itm.item.acceptQty}
                      </TableCell>
                      <TableCell className="quotation__add--table--number">
                        {itm.approxTaxable}
                      </TableCell>
                      <TableCell className="quotation__add--table--number">
                        {itm.tax}
                      </TableCell>
                      <TableCell className="quotation__add--table--number">
                        {itm.taxedValue}
                      </TableCell>
                      <TableCell className="quotation__add--table--number">
                        {itm.netValue}
                      </TableCell>
                      <TableCell
                        className="quotation__add--table--onclick"
                        onClick={() => setSelectedSuppliers(!selectedSuppliers)}
                      >
                        {itm.suppliers.length} Suppliers
                      </TableCell>

                      <TableCell className="quotation__add--table--remarks">
                        {itm.terms}
                      </TableCell>
                      <TableCell className="quotation__add--table--remarks">
                        {itm.paymentTerms}
                      </TableCell>
                      <TableCell className="quotation__add--table--remarks">
                        {itm.remark}
                      </TableCell>
                      <TableCell id="td-center">
                        <img
                          src={Edit}
                          alt=""
                          onClick={() => {
                            setSelectedId(index);
                            handleEditItem(index);
                            setAddItemModal(true);
                            setAddItemOpretion(Operation.UPDATE);
                          }}
                        />
                        <img
                          src={Delete}
                          alt=""
                          onClick={() => {
                            setSelectedId(index);
                            setDeleteModal(!deleteModal);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={7} className="total">
                    {" "}
                    Total
                  </TableCell>
                  <TableCell className="total-count" id="td-right">
                    {totals.presentStck}
                  </TableCell>
                  <TableCell className="total-count" id="td-right">
                    {totals.approxRate}
                  </TableCell>
                  <TableCell className="total-count" id="td-right">
                    {totals.acceptQty}
                  </TableCell>
                  <TableCell className="total-count" id="td-right">
                    {totals.approxTaxable}
                  </TableCell>
                  <TableCell className="total-count" id="td-right">
                    {totals.tax}
                  </TableCell>
                  <TableCell className="total-count" id="td-right">
                    {totals.taxedValue}
                  </TableCell>
                  <TableCell className="total-count" id="td-right">
                    {totals.netValue}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>
        <div className="quotation__add--datablock row g-0">
          <div className="col quotation__add--datablock--frame">
            <div className="quotation__add--datablock--frame--grid">
              {inputJson.map((field, key) => {
                return (
                  <React.Fragment key={key}>
                    <Label>{field.labelName}</Label>
                    <Input
                      value={
                        field.dataType === "date"
                          ? toInputStandardDate(
                              rqForm[field.inputName] as string
                            )
                          : rqForm[field.inputName]
                      }
                      name={field.inputName}
                      onChange={handleRqValueChange}
                      type={field.dataType}
                      required={field.dataType == "date" ? true : false}
                    />
                  </React.Fragment>
                );
              })}
            </div>
          </div>
          <div className="col quotation__add--datablock--frame">
            <div className="quotation__add--datablock--frame--grid">
              {textAreaJson.map((field, key) => {
                return (
                  <React.Fragment key={key}>
                    <Label>{field.labelName}</Label>
                    <TextArea
                      rows={3}
                      name={field.inputName}
                      value={rqForm[field.inputName]}
                      onChange={handleRqValueChange}
                    />
                  </React.Fragment>
                );
              })}
            </div>
          </div>
          <div className="col quotation__add--datablock--frame">
            <div className="quotation__add--datablock--frame--grid">
              <Label>Remarks</Label>
              <TextArea
                rows={3}
                name="remarks"
                value={rqForm.remarks}
                onChange={handleRqValueChange}
              />
            </div>
          </div>
        </div>
        <Button mode="save" onClick={handleSubmit} />
        <Button mode="clear" onClick={handleClear} />
        <Button
          mode="back"
          onClick={() => {
            navigate(-1);
          }}
        />
      </div>

      <CustomModal
        isOpen={selectSubsidary}
        onRequestClose={() => setSelectSubsidary(!selectSubsidary)}
        contentComponent={
          <Subsidiary setFlag={setSelectSubsidary} pageType={PageFor.ADD} />
        }
        style={ViewItemModalStyles}
      />

      <CustomDrawer
        anchor="right"
        open={selectedSuppliers}
        onClose={() => setSelectedSuppliers(!selectedSuppliers)}
      >
        <SelectedSuppliers
          setModalFlag={setSelectedSuppliers}
          pageType={MaterialRequestStatus.APPROVED}
          handleClose={() => {}}
        />
      </CustomDrawer>

      <DeleteModal
        id={selectedId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={
          loading ||
          AddRfqLoading ||
          UpdateRfqLoading ||
          GetRfqByNodeLoading ||
          GetSqlNumberLoading ||
          MrfByNodeLoading
        }
      />
      <CustomModal
        isOpen={addItemModal}
        onRequestClose={() => setAddItemModal(!addItemModal)}
        style={AddModalStyles}
        contentComponent={
          <AddQuotationItemModal
            setModal={setAddItemModal}
            itemsDataState={{
              items,
              setItems,
              selectedId,
              addItemOpretion,
              setAddItemOpretion,
            }}
          />
        }
      />
    </>
  );
};

export default Add;
